export namespace Extensions {
    export const Workbench = 'workbench.contributions.kind';
}
